module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main-box"
  }, [_c('akko-header'), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5 container-box"
  }, [_c('redeem-progress', {
    attrs: {
      "currentStep": _vm.registration_step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex form-area flex-column justify-between"
  }, [_c('div', [_c('activation-code', {
    attrs: {
      "currentStep": _vm.registration_step,
      "checkRedemptionCode": _vm.checkRedemptionCode
    },
    model: {
      value: (_vm.redemption_code),
      callback: function($$v) {
        _vm.redemption_code = $$v
      },
      expression: "redemption_code"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.registration_step === _vm.PERSONAL_INFO),
      expression: "registration_step === PERSONAL_INFO"
    }]
  }, [_c('personal-form', {
    attrs: {
      "title": "Personal Information",
      "subtitle": "Enter your personal information",
      "firstLabel": "Cell Phone Number",
      "secondLabel": "Email Address",
      "autoFocus": "",
      "firstValue": _vm.phone_no,
      "secondValue": _vm.email,
      "phoneError": _vm.phoneError,
      "emailError": _vm.emailError,
      "maxLength": 14
    },
    on: {
      "update:firstValue": function($event) {
        _vm.phone_no = $event
      },
      "update:first-value": function($event) {
        _vm.phone_no = $event
      },
      "update:secondValue": function($event) {
        _vm.email = $event
      },
      "update:second-value": function($event) {
        _vm.email = $event
      }
    }
  })], 1), _vm._v(" "), _c('agreement', {
    attrs: {
      "accept": _vm.accept,
      "registrationStep": _vm.registration_step
    },
    on: {
      "update:accept": function($event) {
        _vm.accept = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorList.length > 0),
      expression: "errorList.length > 0"
    }],
    staticClass: "mb3"
  }, [_c('span', {
    staticClass: "inter-medium red mt3 mb2"
  }, [_vm._v("Error submitting registration:")]), _vm._v(" "), _vm._l((_vm.errorList), function(e, index) {
    return _c('span', {
      key: index,
      staticClass: "red",
      domProps: {
        "innerHTML": _vm._s(e)
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end buttons"
  }, [(_vm.registration_step > _vm.ACTIVATION_CODE) ? _c('ak-button', {
    staticClass: "w4",
    attrs: {
      "shadow": "",
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setCurrentStep(_vm.registration_step - 1)
      }
    }
  }, [_vm._v("\n          Previous\n        ")]) : _vm._e(), _vm._v(" "), _c('ak-button', {
    staticClass: "ml3 w4",
    attrs: {
      "newDisabled": !_vm.enableButton,
      "shadow": "",
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.registration_step === _vm.TERMS_CONDS ?
          _vm.submit() :
          _vm.setCurrentStep(_vm.registration_step + 1)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.registration_step === _vm.TERMS_CONDS ? 'Register' : 'Continue') + "\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-334eb36d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/PartnerRedeem.vue
// module id = 671
// module chunks = 0